(function () {
  var header = document.querySelector('[data-hs-header]');
  var mobileNav = document.getElementById('HalfsonMobileNav');
  var openButton = document.querySelector('[data-action="toggle-mobile-menu"]');
  var closeButton = document.querySelector('[data-action="close-mobile-menu"]');
  var searchOverlay = document.getElementById('HalfsonSearch');
  var searchOpenButton = document.querySelector('[data-action="open-search"]');
  var searchCloseButton = document.querySelector('[data-action="close-search"]');
  var searchInput = document.getElementById('HalfsonSearchInput');

  function setMenu(open) {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (openButton) openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('hs-menu-open', open);
    if (open && closeButton) closeButton.focus();
  }

  if (openButton) openButton.addEventListener('click', function () { setMenu(true); });
  if (closeButton) closeButton.addEventListener('click', function () { setMenu(false); });
  if (mobileNav) {
    mobileNav.addEventListener('click', function (event) {
      if (event.target === mobileNav || event.target.closest('.hs-mobile-nav__links a')) setMenu(false);
    });
  }

  function setSearch(open) {
    if (!searchOverlay) return;
    if (open) setMenu(false);
    searchOverlay.classList.toggle('is-open', open);
    searchOverlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (searchOpenButton) searchOpenButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('hs-search-open', open);
    if (open && searchInput) window.setTimeout(function () { searchInput.focus(); }, 120);
    if (!open && searchOpenButton) searchOpenButton.focus();
  }

  if (searchOpenButton) searchOpenButton.addEventListener('click', function () { setSearch(true); });
  if (searchCloseButton) searchCloseButton.addEventListener('click', function () { setSearch(false); });
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (event) {
      if (event.target === searchOverlay) setSearch(false);
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMenu(false);
      setSearch(false);
    }
  });

  function updateHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  function initScrollReveal() {
    var selectors = [
      '[data-ad-reveal]',
      '.hs-section__head',
      '.hs-product-grid .product-card',
      '.hs-category-card',
      '.hs-manifesto > *',
      '.hs-trust > div',
      '.hs-footer__top > *',
      '.hs-editorial-page > *',
      '.hs-cart-page > *',
      '.hs-search-page > *'
    ];
    var elements = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    if (!elements.length) return;

    elements.forEach(function (element) {
      element.setAttribute('data-hs-reveal', '');
    });

    [
      '.hs-product-grid',
      '.hs-category-grid',
      '.hs-trust'
    ].forEach(function (groupSelector) {
      document.querySelectorAll(groupSelector).forEach(function (group) {
        group.querySelectorAll('[data-hs-reveal]').forEach(function (item, index) {
          item.style.setProperty('--hs-reveal-delay', Math.min(index * 70, 280) + 'ms');
        });
      });
    });

    document.documentElement.classList.add('hs-motion-ready');

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (element) { element.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    elements.forEach(function (element) { observer.observe(element); });
  }

  initScrollReveal();
})();
